import { render } from "./GamesPage.vue?vue&type=template&id=24ceccdd&scoped=true"
import script from "./GamesPage.vue?vue&type=script&lang=js"
export * from "./GamesPage.vue?vue&type=script&lang=js"

import "./GamesPage.vue?vue&type=style&index=0&id=24ceccdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ceccdd"]])

export default __exports__